import React from 'react';

const CommonFooter = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 mt-16">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-8 md:mb-0">
            <h2 className="text-2xl font-bold mb-4 bg-white bg-clip-text text-transparent">HoneymoonSalad</h2>
            <p className="text-gray-400 max-w-md leading-relaxed break-keep">
              함께 자산관리하는 신혼부부를 위한 서비스!
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8">
            <div></div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© 2025 HoneymoonSalad. 모든 권리 보유.</p>
          <div className="flex space-x-4 mt-4 md:mt-0 text-gray-400">honeymoonsalad.official@gmail.com</div>
        </div>
      </div>
    </footer>
  );
};

export default CommonFooter;
